import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'toResourceUrl'})
export class ResourceMultimediaPipe implements PipeTransform {

  transform(id: number) {
    let baseUrl = '/catalogue-formation/api/';
    let serviceUrl = baseUrl + 'ressourcemultimedia/';
    return serviceUrl + id;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/common/utils/image/resource.multimedia.pipe.ts